export default "__VITE_ASSET__BNeDAn7V__"